import React, { useContext } from 'react'
import StyledContainer from './StyledContainer'
import StylesContext from '../context/StylesContext'
import StyledTitle from './StyledTitle';
import ButtonsChart from './ButtonsChart';
import { chartItemProps } from '../hooks/useSessionStorage';

interface ChartCardProps {
  menu_item: chartItemProps;
  showButtons: boolean;
}

const ChartCard: React.FC<ChartCardProps> = ({menu_item, showButtons}) => {  
  const { styles } = useContext(StylesContext);
  return (
    <StyledContainer
      $bgColor={styles.bgCategoryContainer}
      className='chart_card'      
    >
      {
        <>
          <img className='menu_item_img' src={ menu_item.itemImage } alt='Imagem do alimento ou bebida'/>
          <StyledContainer className='title_btn_chart_container'>
            <StyledTitle className='text_chart_item_name' $textColor={styles.textColor}>{menu_item.itemName}</StyledTitle>
            <StyledTitle
              $textColor={styles.secondaryTextColor}
              className='item_price'>{`R$ ${(menu_item.itemPrice * menu_item.quantity).toFixed(2)}`}
            </StyledTitle>
            {
              showButtons ? (<ButtonsChart quantity={menu_item.quantity} itemName={menu_item.itemName} itemPrice={menu_item.itemPrice} />) :
              (<StyledTitle $textColor={styles.secondaryTextColor} className='item-quantity-vocal'>{`Quantidade: ${menu_item.quantity} unidades`}</StyledTitle>)
            }            
          </StyledContainer> 
        </>
      }
    </StyledContainer>
  )
}

export default ChartCard